import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, CheckCircle2, AlertCircle, TicketPercent } from 'lucide-react';

const errText = (e) => (typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Não foi possível validar o cupom');

// Optional discount coupon: validates against the server as the user types and reports {code, percent, final} or null
export const CouponField = ({ checkUrl, headers, onChange, note }) => {
  const [code, setCode] = useState('');
  const [state, setState] = useState(null);
  useEffect(() => {
    const value = code.trim();
    if (!value) { setState(null); onChange(null); return undefined; }
    setState({ loading: true });
    onChange(null);
    const t = setTimeout(() => {
      axios.post(checkUrl, { code: value }, { headers })
        .then(({ data }) => { if (data.valid) { setState({ ok: data }); onChange(data); } else setState({ err: 'Cupom inválido' }); })
        .catch((e) => setState({ err: errText(e) }));
    }, 600);
    return () => clearTimeout(t);
  }, [code]); // eslint-disable-line
  return (
    <div data-testid="coupon-field" style={{ marginBottom: '0.8rem' }}>
      <label style={{ display: 'block', fontSize: '0.78rem', color: '#4a5568' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}><TicketPercent className="w-3.5 h-3.5" />Cupom de desconto (opcional)</span>
        <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} maxLength={40} placeholder="Digite o código" data-testid="coupon-input"
          style={{ width: '100%', padding: '0.55rem 0.65rem', borderRadius: 8, border: `1px solid ${state?.ok ? '#38a169' : state?.err ? '#e53e3e' : '#cbd5e0'}`, fontSize: '0.92rem', marginTop: 3, textTransform: 'uppercase' }} />
      </label>
      {state?.loading && <p data-testid="coupon-checking" style={{ fontSize: '0.75rem', color: '#718096', marginTop: 4, display: 'flex', alignItems: 'center', gap: 4 }}><Loader2 className="w-3 h-3 animate-spin" />Validando cupom...</p>}
      {state?.err && <p data-testid="coupon-error" style={{ fontSize: '0.75rem', color: '#e53e3e', marginTop: 4, display: 'flex', alignItems: 'center', gap: 4 }}><AlertCircle className="w-3 h-3" />{state.err}</p>}
      {state?.ok && <p data-testid="coupon-applied" style={{ fontSize: '0.78rem', color: '#2f855a', marginTop: 4, display: 'flex', alignItems: 'center', gap: 4, fontWeight: 600 }}><CheckCircle2 className="w-3.5 h-3.5" />Cupom {state.ok.code} aplicado: {state.ok.percent}% de desconto{note ? ` ${note}` : ''}</p>}
    </div>
  );
};
